module.exports = __webpack_public_path__ + "dummyVideoAds.png";